import { Injectable } from '@angular/core';
import { BehaviorSubject, forkJoin, Subject } from 'rxjs';
import { HttpParams, HttpResponse } from '@angular/common/http';
import { AuthHttpService } from './auth-http.service';
import { Globals } from '../globals';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ErrorDialogComponent } from '../routes/report/consolidated-events/error-dialog/error-dialog.component';


@Injectable({
    providedIn: 'root'
})
export class SensorService {

    private _sensorData = null;
    private _dataSubject = new BehaviorSubject<any>(this._sensorData);
    public error_message: string;
    public service_data_ready: boolean = false;
    public sensors_in_service: any = [];
    public sensors_in_service_ready: boolean = true;
    public sensorStatus: number;
    public activePlace: any;
    public adminGeneral: boolean;
    public sensorStatusChanged: boolean;
    public changedSensorId: string;
    public filterList: any = [];
    private statusSensorSource = new Subject<boolean>();
    statusSensorSource$ = this.statusSensorSource.asObservable();
    sensorId: string;
    cancelCanDeActive: boolean;
    sensorType: any;
    settings_mode_switch: boolean = false;

    public res_dict_status: any[];
    applied: Boolean;

    constructor(
        private http: AuthHttpService,
        public dialog: MatDialog,
        public Globals: Globals,
    ) {
        this._dataSubject.subscribe({
            next: () => {
            }
        })
    }

    private setData(data: any) {
        this._sensorData = data;
        this._dataSubject.next(data);
    }

    /**
    * @param id {string} - uuid нужного датчика
    * @returns {BehaviorSubject} - субъект, испускающий значения с новым датчиком
    * Эту функцию можно использовать без аргумента (sensor()) и тогда она отдаст
    * субъект без подкачки новых данных
    */
    public sensor(id?: string): BehaviorSubject<any> {
        if (id) {
            this.fetchSensor(id);
        }

        return this._dataSubject;
    }

    public translateStatus = (status_list: string) => {
        const status_arr = status_list.split(', ');

        // console.log('string to status_arr', status_arr);

        // переводим
        const translated_arr = [];
        let translated_status: string;

        status_arr.forEach(word => {
            // меняем на перевод в зависимости от выбранного языка
            const current_lang = this.Globals.lang;
            const found_word = this.res_dict_status.find((word_obj: { code: string; }) => word_obj.code == word);
            if (Boolean(found_word)) {
              const found_name_arr = JSON.parse(found_word.name);
              translated_arr.push(found_name_arr[current_lang]);
            } else {
              const found_name_arr = {'en': 'No status. Check reading', 'es': 'Sin Estado. lectura de cheques', 'ru': 'Нет статуса. Проверьте считывание'};
              translated_arr.push(found_name_arr[current_lang]);
            }
            // console.log('found_name_arr', found_name_arr[current_lang]);
        });
        translated_status = translated_arr.toString();
        // добавляем пробел после запятой
        translated_status = translated_status.split(',').join(', ');
        return translated_status;
    }

    public async fetchSensor(id: string) {
        let params: HttpParams = new HttpParams();
        params = params.set('sensor_id', id);
        this.service_data_ready = false;
        try {
            //получаем датчики, статусы и полосы и объеиняем их в один массив
            const res = await this.http.get('/api/admin-sensors/data', { params }).toPromise();
            let data = res.body[0];

            //let statusParams: HttpParams = new HttpParams();
            let statusParams = { 'sensor_id_list': '' }
            statusParams.sensor_id_list = JSON.stringify([id]);
            let fetchData$ = forkJoin({
                DictStatusData: this.http.get('/api/dict/det_sensor_status_dict'),
                statusData: this.http.post('/api/sensor/status_v', statusParams)
            });

            const statusRes = await fetchData$.toPromise();
            // добавили получение из словаря перевода детальных статусов
            this.res_dict_status = statusRes.DictStatusData.body;

            let res_status = statusRes.statusData.body;
            // далее проверяем таблицу статусов и в случае соответствия выставляем текущий статус
            data.status_v = 0;
            data.status_v_list = '';

            if (res_status.length > 0) {
                res_status.forEach((sv: { sensor_id: any; current_status_code: any; current_status_list: any; }) => {
                    if (sv.sensor_id == data.sensor_id) {
                        data.status_v = sv.current_status_code;
                        data.status_v_list = this.translateStatus(sv.current_status_list);;
                        if (sv.current_status_code == 4) {
                            this.settings_mode_switch = true;
                        } else {
                            this.settings_mode_switch = false;
                        }
                    }
                });
            }
            if (data.del_from_project) {
                data.status_v = 3;
            }
            this.service_data_ready = true;
            this.setData(data);
        } catch (err) {
            console.log(err);
        }
    }

  /**
   * Get sensor in service
   * @param id
   * @param fromDialog
   */
  public async getSensorStatus(id: string, fromDialog?: boolean) {
      this.sensors_in_service_ready = false;
      this.getCurrentSensorStatus(id).subscribe( res => {
          this.sensorStatus = res.body[0].current_status_code;
          this.sensors_in_service_ready = true;
          this.changedSensorId = id;
          if (fromDialog) {
            this._getSensorStatus();
          }
      });
  }

    getCurrentSensorStatus(id: string) {
        try {
            let params: HttpParams = new HttpParams();
            params = params.set('sensor_id', id);
            return this.http.get('/api/sensor/sensor_status', { params });
        } catch (e) {
            console.log(e);
        }

    }

    /**
     * The "Show or hide settings mode" button depends on the page
     */
    public async toggleSettingModeButton() { }

    public clearSensorsGlobalData() {
        this.setData([]);
        this.service_data_ready = false;
    }

    /**
     * Gets info sensor_zone from sensor_params.sensor_zones
     * @param sensorId
     */
    getSensorZones(sensorId: string) {
        try {
            let params: HttpParams = new HttpParams();
            params = params.set('sensor_id', sensorId);
            return this.http.get('/api/sensor_params/sensor_zones', { params });
        } catch (e) {
            console.log(e)
        }
    }

    /**
     * Get data by sensor_id for selects from sensor_params.sensor_lane_zones
     * @param sensorId
     */
    async getSensorLaneZones(sensorId: string) {
        try {
            if (sensorId) {
                let params: HttpParams = new HttpParams();
                params = params.set('sensor_id', sensorId);
                const res = await this.http.get('/api/sensor_params/get_sensor_lane_zones', { params }).toPromise();
                return res.body;
            }
        } catch (e) {
            console.log(e);
        }
    }

    changeSensorStatus(sensorId: string, fromDialog?: boolean) {
        this.checkSensorTypeIsTMs13();
        this.sensors_in_service_ready = false;
        const statusParams = { 'sensor_id': '' };
        statusParams.sensor_id = sensorId;
        this.http.post('/api/sensor/sensor_in_service/update', statusParams).subscribe({
            next: (res: HttpResponse<any>) => {
                this.sensorStatusChanged = true;
                this.getSensorStatus(sensorId, fromDialog).then(() => { });
            },
            error: error => {
                console.error('There was an error!', error);
            }
        });
    }

    /**
     * check if sensor status changed in MatDialog
     */
    _getSensorStatus() {
        this.statusSensorSource.next(null);
    }

    /**
     * Stop for a 300 mill seconds showing dialog <Notice sensor setting mode> than activate
     */
    cancelCanDeActiveFunc() {
        this.cancelCanDeActive = true;
        setTimeout(() => this.cancelCanDeActive = false, 500);
    }

    /**
     * Show Error pop up if some thing wrong while getting reports
     * @param error
     */
    showErrorPopUp(error: any) {
        if (error) {
            const dialogRef = this.dialog.open(ErrorDialogComponent, <MatDialogConfig>{
                data: {
                    text: error.result_message,
                }
            });
          dialogRef.afterClosed().subscribe(() => {
            this.applied = false;
          });
        }
    }

    checkSensorTypeIsTMs13() {
        if (this.sensorType) {
            return this.sensorType.indexOf('UMRR-13') !== -1 || this.sensorType.indexOf('UMRR-14') !== -1;
        }
    }

    checkSensorTypeIsTMs11() {
        if (this.sensorType) {
            return this.sensorType.indexOf('UMRR-11') !== -1 || this.sensorType.indexOf('UMRR-12') !== -1;
        }
    }
}
